import { z } from 'zod';
export const createProfessorSchema = z.object({
    first_name: z.string().min(2, 'El nombre debe tener al menos 2 caracteres').max(100),
    last_name: z.string().min(2, 'Los apellidos deben tener al menos 2 caracteres').max(200),
    email: z.string().email('Email inválido'),
    phone: z
        .string()
        .regex(/^[6789]\d{8}$/, 'Teléfono inválido')
        .optional(),
    opposition_id: z.string().uuid('Oposición no válida'),
    subject_ids: z.array(z.string().uuid()).default([]),
    can_collect_payments: z.boolean().default(false),
    bio: z.string().max(1000).optional(),
});
export const updateProfessorSchema = z.object({
    first_name: z.string().min(2).max(100).optional(),
    last_name: z.string().min(2).max(200).optional(),
    phone: z
        .string()
        .regex(/^[6789]\d{8}$/, 'Teléfono inválido')
        .optional(),
    opposition_id: z.string().uuid().optional(),
    subject_ids: z.array(z.string().uuid()).optional(),
    can_collect_payments: z.boolean().optional(),
    bio: z.string().max(1000).optional(),
});
//# sourceMappingURL=professor.schema.js.map